import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconWaitCondition(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M12 22a.97.97 0 0 1-.713-.288A.97.97 0 0 1 11 21V3q0-.424.287-.712A.97.97 0 0 1 12 2q.424 0 .713.288Q13 2.575 13 3v18q0 .424-.287.712A.97.97 0 0 1 12 22m7-17V3q.824 0 1.413.587Q21 4.176 21 5zm0 8v-2h2v2zm0 8v-2h2q0 .824-.587 1.413A1.93 1.93 0 0 1 19 21m0-12V7h2v2zm0 8v-2h2v2zm-4 4v-2h2v2zm0-16V3h2v2z"
      />
      <path
        fill="currentColor"
        d="M11 5H7v2q0 .525.118 1H11v5q-1.65 0-2.825 1.175T7 17v2h4v2H4a.97.97 0 0 1-.713-.288A.97.97 0 0 1 3 20q0-.424.287-.712A.97.97 0 0 1 4 19h1v-2q0-1.525.713-2.863A5.57 5.57 0 0 1 7.7 12a5.57 5.57 0 0 1-1.987-2.138A6 6 0 0 1 5 7V5H4a.97.97 0 0 1-.713-.288A.97.97 0 0 1 3 4a.97.97 0 0 1 .287-.713A.97.97 0 0 1 4 3h7z"
      />
    </BaseIcon>
  );
}
